import Slider from "react-slick";
import { useState, useEffect, useRef } from 'react';
import "./slick.css";
import "./slick-theme.css";
import Button from '../button';
import colors from "../../themes/Colors";

export default function SimpleSlider({ data, onClick, active }) {
  const [hasSetPosition, setHasSetPosition] = useState(false);
  const slider = useRef();
  const initialSlide = 0

  const buttonStyle = {
    borderRadius: '10px',
    width: '240px',
    height: '50px'
  }

  const activeButton = {

  }

  useEffect(() => {
    if (slider.current && !hasSetPosition) {
      slider.current.slickGoTo(initialSlide);
      setHasSetPosition(true);
    }
  }, [initialSlide, hasSetPosition, slider]);

  const settings = {
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 5,
    slidesToScroll: 2,
    initialSlide: 0,
    
    // responsive: [
    //   {
    //     breakpoint: 1024,
    //     settings: {
    //       slidesToShow: 3,
    //       slidesToScroll: 3,
    //       infinite: true,
    //       dots: true
    //     }
    //   },
    //   {
    //     breakpoint: 600,
    //     settings: {
    //       slidesToShow: 2,
    //       slidesToScroll: 2,
    //       initialSlide: 2
    //     }
    //   },
    //   {
    //     breakpoint: 480,
    //     settings: {
    //       slidesToShow: 1,
    //       slidesToScroll: 1
    //     }
    //   }
    // ]
  };
  return (
    <Slider ref={slider} {...settings}>
      {data.map((item) => 
        <Button 
            text={item.display}
            buttonStyle={buttonStyle}
            backgroundColor={item.key === active.key ? colors.color25 : colors.color9}
            textColor={item.key === active.key ? colors.color3 :colors.color7}
            onClick={()=> onClick(item)}
        />)}
    </Slider>
  )
}